<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="7">
          <v-sheet class="neu-glow with-radius">
            <v-card-text class="pa-0">
              <v-row class="ma-0">
                <v-col cols="12" md="12">
                  <div class="my-8 text-center">
                    <div class="text-h4 d-flex justify-center align-center">
                      <b>Log In</b>
                    </div>
                    <div class="subtitle-1 mt-3">Hello, Welcome Back!</div>
                  </div>
                  <v-sheet max-width="380" class="mx-auto" color="transparent">
                    <v-form
                      @submit.prevent="$v.$invalid ? null : submit()"
                      ref="form"
                    >
                      <alert-message></alert-message>

                      <v-text-field
                        :error-messages="fieldErrors('form.username')"
                        @input="$v.form.username.$touch()"
                        @blur="$v.form.username.$touch()"
                        prepend-inner-icon="perm_identity"
                        v-model="form.username"
                        label="Username"
                        solo
                        flat
                      />
                      <v-text-field
                        :error-messages="fieldErrors('form.password')"
                        :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="showPwd ? 'text' : 'password'"
                        @input="$v.form.password.$touch()"
                        @blur="$v.form.password.$touch()"
                        prepend-inner-icon="vpn_key"
                        v-model="form.password"
                        label="Password"
                        @click:append="showPwd = !showPwd"
                        solo
                        flat
                      />
                      <div class="d-flex flex-no-wrap justify-space-between">
                        <!-- <v-checkbox
                          v-model="form.rememberMe"
                          label="Remember Me"
                          class="mt-0"
                        ></v-checkbox> -->
                      
                      </div>

                      <v-btn
                        block
                        type="submit"
                        :loading="loading"
                        :disabled="$v.$invalid"
                        >Sign In</v-btn
                      >
                      
                      <div class="text-center my-5">
                        Don't have account ?
                        <router-link to="signup" class="py-1 no-text-decoration"
                          >Create Account</router-link
                        > Or   <router-link
                          to="forgot-password"
                          class="py-1 no-text-decoration"
                          >Forgot Password
                        </router-link>
                      </div>
                    </v-form>
                  </v-sheet>
                </v-col>
              </v-row>
            </v-card-text>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script>
// Validations
import { required, minLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { mapActions, mapState } from "vuex";
import AlertMessage from "src/components/AlertMessage";

// const defaultForm = {
//   username: "abc",
//   password: "testinG123!",
//   rememberMe: false,
// };

const defaultForm = {
  username: "",
  password: "",
  rememberMe: false,
};

export default {
  components: {
    AlertMessage,
  },
  mixins: [validationMixin],
  validations: {
    form: {
      username: { required },
      password: {
        required,
        minLength: minLength(6),
      },
    },
  },
  validationMessages: {
    form: {
      username: {
        required: "Please enter username",
      },
      password: {
        required: "Please enter password",
        minLength: "Password must be of 6 characters",
      },
    },
  },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      showPwd: false,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  methods: {
    ...mapActions("account", ["login"]),
    async submit() {
      this.loading = true;
      await this.login(this.form);
      if (!this.account.status.error) {
        this.resetForm();
        this.$v.$reset();
      }
      this.loading = false;
    },
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      // this.$refs.form.reset();
    },
  },
};
</script>
